<template>
    <div class="love">
        <div class="pulse">
            <div class="likeIconWrapper">
                <LikeIcon class="likeButton"
                    :isLiked="isLiked"
                    :disableLikeAction="false"
                    :animate="animate"
                    @handleLike="handleLike"/>
            </div>
        </div>
        <Heading :h="2" size="l" weight="regular">
            {{ content.loveForArt }}
        </Heading>
        <Heading :h="3" size="xxl">
            {{ content.bringsUsTogether }}
        </Heading>
    </div>
</template>

<script>
    import LikeIcon from '@/components/templates/LikeIcon'

    export default {
        name: 'Love',
        components: {
            LikeIcon
        },
        props: {
            content: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                isLiked: false,
                animate: false
            }
        },
        methods: {
            handleLike() {
                if(this.isLiked === false) {
                    this.animate = true
                    setTimeout(() => {
                        this.animate = false
                    }, 750)
                }
                this.isLiked = !this.isLiked
            }
        }
    }
</script>

<style scoped lang="scss">
    .love {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .h2 {
        margin: 2rem 0 1rem 0;
    }

    .h3 {
        margin: 0;
    }

    .h2, .h3 {
        text-align: center;
    }

    .pulse {
        animation: pulse 2s infinite;
    }

    .likeIconWrapper {
        transform: scale(6);
        margin-bottom: 4rem;

        .transparent {
            padding: 0 !important;
        }
    }

    .likeButton {
        padding: 0 !important;

        &:focus {
            box-shadow: none !important;
        }
    }

    @keyframes pulse {
        0% {
            transform: scale(0.8);
        }

        70% {
            transform: scale(1);
        }

        100% {
            transform: scale(0.8);
        }
    }
</style>